import { Trans } from 'react-i18next'
import { v4 as uuid4 } from 'uuid'

import { VariableResultSessionID, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'

import { appIconKeys } from '@/shared/icons/constants'

export default function VariableSessionID({
  id,
  onChange,
}: {
  id?: string
  onChange: (value: VariableResultSessionID) => void
}) {
  return (
    <div
      id={id}
      onClick={() => {
        onChange({
          id: uuid4(),
          flag: VariableSelectFeatureFlag.SessionID,
        })
      }}
      className='flex-c w-full sdd-item'
    >
      <div className='flex-c w-full pointer-events-none'>
        <MaterialIcon icon={appIconKeys.tableSession} size={16} />
        <div className='pointer-events-none'>
          <Trans>Session ID</Trans>
        </div>
      </div>
    </div>
  )
}
